<template>
  <section class="reviews-section">
    <header class="reviews-heading">
      <div>
        <span class="section-kicker">TESTIMONIOS</span>
        <h2>La confianza también se construye en la operación</h2>
      </div>
      <div class="rating-summary" aria-label="Calificación promedio de los testimonios">
        <strong>{{ averageScore }}</strong>
        <span class="summary-stars" aria-hidden="true">★★★★★</span>
        <small>Promedio de experiencias compartidas</small>
      </div>
    </header>

    <div class="reviews-grid">
        <article v-for="(review, index) in reviews" :key="review.sector" class="review-card" :class="{ featured: index === 0 }">
          <div class="review-top">
            <span class="quote-mark" aria-hidden="true">“</span>
            <span class="review-score">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#fbbf24" viewBox="0 0 16 16">
                  <path d="M8 12.5l-3.09 1.63.59-3.44L2 7.87l3.46-.5L8 4l1.54 3.37 3.46.5-2.5 2.32.59 3.44z"/>
                </svg>
                {{ review.score }}
            </span>
          </div>

          <blockquote>{{ review.text }}</blockquote>
          <footer>
            <span class="sector-marker"></span>
            <div><strong>{{ review.sector }}</strong><small>Cliente verificado</small></div>
          </footer>
        </article>
    </div>
  </section>
</template>

<script>
export default {
  name: "CustomerReviews",
  computed: {
    averageScore() {
      const total = this.reviews.reduce((sum, review) => sum + Number(review.score), 0);
      return (total / this.reviews.length).toFixed(1);
    }
  },
  data() {
    return {
      reviews: [
        {
          sector: "Editorial",
          score: "5.0",
          text: "Es una empresa con experiencia y conocimiento en Netsuite, facilita las integraciones y tiene la capacidad de respuesta rápida, soporte y claridad en el proyecto."
        },
        {
          sector: "Soluciones de Acero",
          score: "4.9",
          text: "Nivel de programación muy bueno, con un equipo de trabajo profesional y con mucha experiencia en el tema de Netsuite."
        },
        {
          sector: "Refacciones Transporte Pesado",
          score: "5.0",
          text: "Consideramos hasta ahora que han tenido mucha ética para trabajar con nuestros procesos y mucha apertura para trabajar. Excelentes personas y soporte profesional."
        },
        {
          sector: "Comerciantes de Bebidas Alcohólicas",
          score: "4.8",
          text: "Un gran equipo, muy profesional que resuelve."
        },
        {
          sector: "Centro de Investigación",
          score: "5.0",
          text: "Nos dieron solución rápida a un requerimiento de último momento."
        }
      ]
    };
  }
};
</script>

<style scoped>
.reviews-section {
  position: relative;
  padding: 0;
}

.reviews-heading {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 50px;
  margin-bottom: 46px;
}

.section-kicker {
  display: block;
  margin-bottom: 16px;
  color: #073b8c;
  font-size: .74rem;
  font-weight: 800;
  letter-spacing: .12em;
}

.reviews-heading h2 {
  max-width: 720px;
  margin: 0;
  color: #101828;
  font-size: clamp(2rem, 3.7vw, 3.1rem);
  font-weight: 800;
  line-height: 1.08;
}

.rating-summary {
  flex: 0 0 230px;
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  column-gap: 12px;
  padding-left: 22px;
  border-left: 1px solid #dbe3ee;
}

.rating-summary strong { grid-row: 1 / 3; color: #101828; font-size: 2.6rem; line-height: 1; }
.summary-stars { color: #e9a513; font-size: .85rem; letter-spacing: .08em; }
.rating-summary small { color: #667085; font-size: .7rem; line-height: 1.25; }

.reviews-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 16px;
}

.review-card {
  grid-column: span 2;
  display: flex;
  flex-direction: column;
  min-height: 285px;
  padding: 28px;
  border: 1px solid #dbe3ee;
  border-radius: 8px;
  background: #fff;
  transition: transform .25s ease, border-color .25s ease, box-shadow .25s ease;
}

.review-card:nth-child(4) { grid-column: 2 / span 2; }
.review-card:nth-child(5) { grid-column: 4 / span 2; }

.review-card.featured {
  color: #fff;
  background: #0c1b33;
  border-color: #0c1b33;
}

.review-card:hover {
  transform: translateY(-4px);
  border-color: #9bc0fa;
  box-shadow: 0 18px 45px rgba(16, 24, 40, .09);
}

.review-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 22px;
}

.quote-mark {
  height: 32px;
  color: #146ef5;
  font-family: Georgia, serif;
  font-size: 3.5rem;
  line-height: 1;
}

.review-score {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 0.95rem;
  font-weight: 800;
  color: #344054;
}

.featured .review-score { color: #fff; }

blockquote {
  flex: 1;
  margin: 0 0 28px;
  color: #344054;
  font-size: 1rem;
  line-height: 1.7;
}

.featured blockquote { color: #d7e0ed; }

.review-card footer {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-top: 18px;
  border-top: 1px solid #e4e7ec;
}

.featured footer { border-top-color: rgba(255, 255, 255, .14); }
.sector-marker { width: 3px; height: 32px; background: #146ef5; }
.review-card footer div { display: flex; flex-direction: column; gap: 2px; }
.review-card footer strong { color: #101828; font-size: .78rem; letter-spacing: .04em; text-transform: uppercase; }
.review-card footer small { color: #667085; font-size: .7rem; }
.featured footer strong { color: #fff; }
.featured footer small { color: #9eacc0; }

@media (max-width: 991px) {
  .reviews-heading { align-items: flex-start; flex-direction: column; gap: 28px; }
  .rating-summary { flex-basis: auto; }
  .review-card { grid-column: span 3; }
  .review-card:nth-child(4), .review-card:nth-child(5) { grid-column: span 3; }
}

@media (max-width: 575px) {
  .reviews-grid { grid-template-columns: 1fr; }
  .review-card, .review-card:nth-child(4), .review-card:nth-child(5) { grid-column: 1; min-height: auto; padding: 24px; }
  .rating-summary { padding-left: 0; border-left: 0; }
}

@media (prefers-reduced-motion: reduce) {
  .review-card { transition: none; }
}
</style>